import React, { memo } from 'react';
import { OtpForm } from '../../components/auth/otp';

const OtpScreen = memo(() => {
  return (
    <div className="flex flex-1 bg-white w-full h-[100vh]">
      <OtpForm />
    </div>
  );
});

OtpScreen.displayName = 'OtpScreen';

export { OtpScreen };
